import { cardsData } from '@/mocks/comics';

export default function CardsSection() {
  return (
    <section id="cards" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            编辑精选
          </h2>
          <p className="text-sm text-foreground-500">
            编辑团队为你精心挑选的优质漫画
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {cardsData.slice(0, 7).map((card) => (
            <a
              key={card.id}
              href="#cards"
              className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 right-3">
                  <span className={`inline-block text-xs font-bold px-2.5 py-1 rounded-full ${
                    card.badge === 'HOT' ? 'bg-accent-500 text-white' :
                    card.badge === 'NEW' ? 'bg-primary-500 text-white' :
                    'bg-secondary-500 text-white'
                  }`}>
                    {card.badge}
                  </span>
                </div>
              </div>

              <div className="p-4 md:p-5">
                <span className="inline-block text-xs text-secondary-600 bg-secondary-50 px-2 py-0.5 rounded mb-2">
                  {card.tag}
                </span>
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1.5">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}